import { VehicleStatus } from "@1games-ru/region-shared/dist/enums/vehicle/vehicle";
import { VehicleRelatedDto } from "@1games-ru/region-shared/dist/types/vehicle/vehicle.v3";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { SoundButton, SoundModal } from "@/shared/ui";
import Loader from "@/shared/ui/Loader";
import VehicleCardButton from "@/shared/widgets/VehicleCardButton";
import TransportWarehouseTransportAddress from "@/domains/transportWarehouse/components/transport/TransportWarehouseTransportAddress";

type Props = {
  onClose: () => void;
  onPin: (vehicleId: number) => void;
  isPinning: boolean;
  activeVehicleId: number;
  onChangeActiveVehicleId: (vehicleId: number) => void;
  vehicles?: VehicleRelatedDto[];
  isLoading?: boolean;
};

export default function TransportWarehouseTransportPinTransportModal({
  onClose,
  activeVehicleId,
  onChangeActiveVehicleId,
  isPinning,
  onPin,
  vehicles,
  isLoading,
}: Props) {
  const { t } = useTranslation("transportWarehouse");

  return (
    <SoundModal
      open
      onClose={onClose}
      className="successShadow w-[39.75rem] h-[36.75rem]"
      // classNameOverlay="absolute"
      // container={TRANSPORT_WAREHOUSE_CONTAINER}
      dataMzAccent="success"
    >
      <div className="relative h-full flex flex-col gap-5 items-start">
        <div>
          <div className="text-18 font-bold"> {t("transportWarehouse.yourAuto")}</div>
          <div className="w-full text-15 font-medium text-white/60">
            {t("transportWarehouse.chooseAuto")}
          </div>
        </div>
        <div className="relative grow w-full">
          <div className="absolute inset-0 overflow-hidden overflow-y-auto -mr-2 pr-2 [--scrollbar-thumb-bg:#434242]">
            {isLoading ? (
              <Loader />
            ) : (
              <div className="grow grid grid-cols-3 gap-1.5">
                {vehicles.map((item) => (
                  <VehicleCardButton
                    key={item.id}
                    model={item.model}
                    brand={item.brand}
                    status={item.status}
                    className="h-auto w-full"
                    isActive={activeVehicleId === item.id}
                    onClick={() => onChangeActiveVehicleId(item.id)}
                  >
                    {item?.address && (
                      <TransportWarehouseTransportAddress
                        address={item.address}
                        className="z-2 absolute top-2 left-2"
                      />
                    )}
                    {item.status !== VehicleStatus.Pending && (
                      <div
                        className={clsx(
                          "absolute z-2 left-2 top-[5rem] text-10 font-bold text-gray",
                          "bg-gradient-to-r from-gray/50 via-50% via-gray/50 to-accent-muted/30 py-2 px-2.5 rounded-[0.375rem] backdrop-blur-[2px]",
                        )}
                      >
                        {t(`transportWarehouse.${item.status.toLowerCase()}`)}
                      </div>
                    )}
                  </VehicleCardButton>
                ))}
              </div>
            )}
          </div>
        </div>

        <SoundButton
          className="w-full h-11 mt-auto"
          onClick={() => onPin(activeVehicleId)}
          disabled={isPinning || isLoading || !activeVehicleId}
          loading={isPinning}
        >
          {t("transportWarehouse.pinTransport")}
        </SoundButton>
      </div>
    </SoundModal>
  );
}
